import React from "react";
import { logo } from "../../constants";

const SellerFooter = () => {
	const d = new Date();
	let year = d.getFullYear();
	return (
		<footer>
			<div className="container">
				<div className="row">
					<div className="col-lg-4">
						<div className="footer-widget-wrapper">
							<div className="logo-wrapper">
								<figure>
									<img src={logo} className="img-fluid" alt="" />
								</figure>
							</div>
							<div className="footer-content-wrapper">
								<h5>Apricot Market</h5>
								<p>
									Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
									do eiusmod tempor incididunt
								</p>
							</div>
						</div>
					</div>
					<div className="col-lg-3">
						<div className="footer-widget-2-wrapper">
							<div className="footer-content-wrapper">
								<div className="heading-wrapper">
									<h5>Useful Links</h5>
								</div>
								<div className="footer-links-wrapper">
									<ul>
										<li>
											<a href="/about">About us</a>
										</li>

										<li>
											<a href="/contact">Contact us</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-3">
						<div className="footer-widget-2-wrapper">
							<div className="footer-content-wrapper">
								<div className="heading-wrapper">
									<h5>Help Center</h5>
								</div>
								<div className="footer-links-wrapper">
									<ul>
										<li>
											<a href="/faqs">Faqs</a>
										</li>
										<li>
											<a href="/policy">Privacy Policy</a>
										</li>
										<li>
											<a href="/policy">Legal Policy</a>
										</li>
										<li>
											<a href="/Terms">Terms And Conditions</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
					<div className="col-lg-2">
						<div className="footer-widget-2-wrapper">
							<div className="footer-content-wrapper">
								<div className="heading-wrapper">
									<h5>Apricot Business</h5>
								</div>
								<div className="footer-links-wrapper">
									<ul>
										<li>
											<a href="/Advertise">Advertise With us</a>
										</li>
									</ul>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="copyright">
				<div className="container">
					<div className="row">
						<div className="col-lg-12">
							<div className="content-wrapper">
								<p>© {year} Apricot. All Rights Reserved</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default SellerFooter;
